<script setup>
const api = useFeathers()
const router = useRouter()
const route = useRoute()
const authStore = useAuthStore()

const unsubscribeSuccess = ref(false)
const hasError = ref(false)
const errorMessage = ref(null)

onBeforeMount(async () => {
  if (!route.query.token || !route.query.email) {
    hasError.value = true
    return
  }

  const response = await api
    .service('customer-contacts')
    .unsubscribeMail({
      token: route.query.token,
      email: decodeURIComponent(route.query.email.toString()),
    })
    .catch(async (e) => {
      hasError.value = true
      errorMessage.value = e.message.replace(/\.$/, '')
      return null
    })

  if (response && !hasError.value) {
    unsubscribeSuccess.value = true
  }
})
</script>

<template>
  <template v-if="hasError">
    <div class="flex column flex-center text-center q-px-sm-lg q-pb-sm-lg">
      <q-avatar size="6rem">
        <q-icon name="sym_o_error_outline" color="negative" size="4rem" />
      </q-avatar>
      <span>
        {{ $t('Shared.Unsubscribe-mail.The link is invalid') }}
      </span>
    </div>
  </template>
  <template v-if="unsubscribeSuccess">
    <div class="flex column flex-center text-center q-px-sm-lg q-pb-sm-lg">
      <q-avatar size="6rem">
        <q-icon name="sym_o_done_outline" color="positive" size="4rem" />
      </q-avatar>
      <span>{{
        $t('Shared.Unsubscribe-mail.The email address has been successfully unsubscribed', {
          email: decodeURIComponent(route.query.email.toString()),
        })
      }}</span>
    </div>
  </template>
</template>

<style scoped></style>
